/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/components/view-filter-bottomsheet/shop.view-filter-bottomsheet.component.ts.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {ShopViewComponent} from '../view/shop.view.component';

/**
 * Zweck: Beschreibt class ShopViewFilterBottomsheetComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.view-filter-bottomsheet.component.html',
    styleUrls: ['shop.view-filter-bottomsheet.component.scss'],
    standalone: false
})
export class ShopViewFilterBottomsheetComponent implements OnInit {

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: ShopViewComponent,
              private _bottomSheetRef: MatBottomSheetRef<ShopViewFilterBottomsheetComponent>) {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
  }


}
